import React, { useState } from "react";

const SystemSettings = () => {
  const [settings, setSettings] = useState({
    maintenanceMode: false,
    allowNewRegistrations: true,
    maxUsersPerPlan: 1000,
    systemNotification: "",
  });

  const handleSettingChange = (key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log("Saving settings:", settings);
    alert("Settings saved successfully!");
  };

  return (
    <div className="p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            System Settings
          </h1>
          <p className="text-gray-600">
            Manage global system configurations and settings
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* System Status */}
            <div className="space-y-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                System Status
              </h2>

              <div className="flex items-center justify-between">
                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Maintenance Mode
                  </label>
                  <p className="text-xs text-gray-500">
                    Enable to block user access for maintenance
                  </p>
                </div>
                <button
                  onClick={() =>
                    handleSettingChange(
                      "maintenanceMode",
                      !settings.maintenanceMode
                    )
                  }
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                    settings.maintenanceMode ? "bg-red-600" : "bg-gray-200"
                  }`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      settings.maintenanceMode
                        ? "translate-x-6"
                        : "translate-x-1"
                    }`}
                  />
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Allow New Registrations
                  </label>
                  <p className="text-xs text-gray-500">
                    Enable new user account creation
                  </p>
                </div>
                <button
                  onClick={() =>
                    handleSettingChange(
                      "allowNewRegistrations",
                      !settings.allowNewRegistrations
                    )
                  }
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                    settings.allowNewRegistrations
                      ? "bg-green-600"
                      : "bg-gray-200"
                  }`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      settings.allowNewRegistrations
                        ? "translate-x-6"
                        : "translate-x-1"
                    }`}
                  />
                </button>
              </div>
            </div>

            {/* Limits */}
            <div className="space-y-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                System Limits
              </h2>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Maximum Users Per Plan
                </label>
                <input
                  type="number"
                  value={settings.maxUsersPerPlan}
                  onChange={(e) =>
                    handleSettingChange(
                      "maxUsersPerPlan",
                      parseInt(e.target.value)
                    )
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>

          {/* System Notification */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              System Notifications
            </h2>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Global Notification Message
              </label>
              <textarea
                value={settings.systemNotification}
                onChange={(e) =>
                  handleSettingChange("systemNotification", e.target.value)
                }
                rows={4}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter a system-wide notification message (optional)"
              />
              <p className="text-xs text-gray-500 mt-1">
                This message will be displayed to all users across the platform
              </p>
            </div>
          </div>

          {/* Save Button */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="flex justify-end">
              <button
                onClick={handleSave}
                className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors"
              >
                Save Settings
              </button>
            </div>
          </div>
        </div>

        {/* System Information */}
        <div className="mt-6 bg-gray-50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            System Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div>
              <span className="font-medium text-gray-600">Version:</span>
              <span className="ml-2 text-gray-800">1.0.0</span>
            </div>
            <div>
              <span className="font-medium text-gray-600">Environment:</span>
              <span className="ml-2 text-gray-800">Development</span>
            </div>
            <div>
              <span className="font-medium text-gray-600">Last Updated:</span>
              <span className="ml-2 text-gray-800">
                {new Date().toLocaleDateString()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemSettings;
